// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app {\n  font-family: Avenir, Helvetica, Arial, sans-serif;\n  color: #000000;\n}\n.container {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n}\n.Site-content {\n  flex: 1;\n}\n", ""]);
// Exports
module.exports = exports;
